import { Card, CardTitle } from "reactstrap";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
`

export const Wrapper = styled(Card)`
  width: 480px;
`

export const Title = styled(CardTitle)`
  padding: 1.5rem;
  text-align: center;
`